export default "__VITE_ASSET__fb632830__"